/**
 * Created by RUSS_ on 18.09.2018
 */
import { getBrowserInfo } from "../api/browser";

window.mLastBrowserInfo = window.mLastBrowserInfo || null;
window.firstBrowserRequestStarted = window.firstBrowserRequestStarted || false;
window.browserInfoResolves = window.browserInfoResolves || [];
export function waitForBrowserInfo() {
  return new Promise((res, rej) => {
    // res({ data: { country: "US", language: "RU" } });
    if (window.mLastBrowserInfo) {
      res(window.mLastBrowserInfo);
    } else if (window.firstBrowserRequestStarted) {
      window.browserInfoResolves.push(res);
    } else {
      window.firstBrowserRequestStarted = true;
      getBrowserInfo().then(answer => {
        window.mLastBrowserInfo = answer;
        for (let i = 0; i < window.browserInfoResolves.length; i++) {
          window.browserInfoResolves[i](window.mLastBrowserInfo);
        }
        res(answer);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src-cookie-manager/managers/browser-manager.js